import React from 'react';

import PropTypes from 'prop-types';
import { Skeleton } from '@/components/ui/skeleton';

import Avatar from './Avatar';

const AVATAR_SIZE = 'sm';

const AvatarWithName = ({ avatarColor, fullName, initials }) => (
  <div className="flex min-w-0 gap-2 items-center">
    <Avatar backgroundColor={avatarColor} initials={initials} size={AVATAR_SIZE} />
    <span className="truncate">{fullName}</span>
  </div>
);

AvatarWithName.Skeleton = function () {
  return (
    <div className="flex gap-2 items-center">
      <Avatar.Skeleton size={AVATAR_SIZE} />
      <Skeleton className="h-5 w-32" />
    </div>
  );
};

AvatarWithName.propTypes = {
  avatarColor: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  initials: PropTypes.string.isRequired,
};

export default AvatarWithName;
